import { useState, useEffect } from 'react';

/**
 * App yüklenmeden olacak logicleri içerir.
 * Preloader ekranı gibi.
 */

const useApp = () => {
  const [appLoading, setAppLoading] = useState(false);

  // giriş animasyonu için timer.
  useEffect(() => {
    const timeout = setTimeout(() => {
      setAppLoading(false);
    }, 1000);

    return () => clearTimeout(timeout);
  }, []);

  return appLoading;
};

export default useApp;
